<template>
  <action-panel-selected-items :separator="show" />
  <template v-if="show">
    <aw-dropdown
      placement="bottom-end"
      :offset="[0, 6]"
      class="inline-flex items-center justify-center cursor-pointer"
      v-if="selectedRev"
    >
      <template v-slot:btn="{ toggle }">
        <div @click="toggle" class="flex items-center justify-center" v-aw-driver-element="'DocumentVersions'">
          <ui-pictogram class="mr-1.5" :user="selectedRev.published__user ? selectedRev.published__user : (selectedRev.created__user ? selectedRev.created__user : undefined)" v-if="selectedRev.published__user || selectedRev.created__user" />
          <span class="font-semibold mr-1" :class="{ 'text-red-600': !selectedRev.published, 'text-green-600': selectedRev.id === publishedRev?.id }">{{ revText(selectedRev) }}</span>
          <aw-icon
            icon="chevron-down"
            class="w-4 h-4  text-gray-500"
          ></aw-icon>
        </div>
      </template>
      <template v-slot:dropdown="{ opened, dropdown, close }">
        <div
          v-show="opened"
          :ref="dropdown"
          class="Dropdown Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10 max-h-72 overflow-y-auto"
        >
          <nav class="p-0">
            <template v-for="rev in bcDocumentStore.revisions" :key="rev.id">
            <div class="p-2 relative">
              <a class="flex items-center space-x-2" :href="rev.url" @click="close">
                <ui-pictogram :user="rev.published__user ? rev.published__user : (rev.created__user ? rev.created__user : undefined)" v-if="rev.published__user || rev.created__user" />
                <span class="flex-grow font-medium" :class="{ 'text-red-600': !rev.published, 'text-green-600': rev.id === publishedRev?.id }">{{ revText(rev) }}</span>
                <span v-if="selectedRev?.id === rev.id"
                  ><aw-icon
                    icon="tick"
                    class="relative w-4 h-4  text-bc-blue"
                  ></aw-icon
                ></span>
              </a>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
            </template>
          </nav>
        </div>
      </template>
    </aw-dropdown>
    <!--
    <span class="mx-2">|</span>
    <span 
      @click="showInfo"
      class="inline-flex cursor-pointer hover:text-gray-800"
    >
      <aw-icon icon="info" class="w-4 h-4 "></aw-icon>
    </span>
    -->
  </template>
</template>

<script>
import formatDate from 'nette-base-module/js/utils/formatDate'
import DocumentStore from '../../mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  computed: {
    show () {
      return this.bcDocumentStore.document.can_edit
    },
    selectedRev () {
      return this.bcDocumentStore.revisions.filter(rev => rev.id === this.bcDocumentStore.document.bc_document_rev_id)[0]
    },
    publishedRev () {
      return this.bcDocumentStore.revisions.filter(rev => rev.id === this.bcDocumentStore.document.published__bc_document_rev_id)[0]
    },
  },
  methods: {
    revText (rev) {
      return (rev.id === this.publishedRev?.id
        ? this.$t('Published') + ' - ' + formatDate(rev.published, 'd. m. y H:i')
        : ( !rev.published ? this.$t('Last edit') + ' - ' + formatDate(rev.created, 'd. m. y H:i') : this.$t('Revision') + ' ' + rev.revision + ' - ' + formatDate(rev.published, 'd. m. y H:i')))
    },
    showInfo() {
      this.$store.commit('nette/updateControl', {
        controlName: 'info',
        data: true,
        key: 'showModal'
      })
    }
  }
};
</script>

<style lang="scss" scoped></style>
